import { FormField, Heading, ReadOnlyField, RecordContent, RecordFooter, useTitleChange } from '@msaf/core-react'
import { useEffect, useState } from 'react'
import { TOOLTIP } from '../../../../../constants/tooltips'
import { AquiferFieldsView } from '../../../../../types/form-types'
import WellViewButtons from '../../../../components/wells/well-view-buttons'
import { useGetWellData } from '../../../../hooks/use-api'
import { useWellId } from '../../../../hooks/use-well-id'

export default function ViewWellAquifer() {
  useTitleChange('View Well | Aquifer')
  const [fields, setFields] = useState<Partial<AquiferFieldsView>>({})
  const id = useWellId()
  const url = `/wells/${id}/aquifer/view`
  const { isLoading, isSuccess, data } = useGetWellData(url)

  useEffect(() => {
    if (isSuccess && data?.state) {
      setFields(data.state)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data?.state])

  return (
    <>
      <RecordContent>
        <Heading isSkeleton={isLoading} level={2}>
          Aquifer
        </Heading>

        <Heading isSkeleton={isLoading} level={3}>
          Details
        </Heading>

        <FormField
          toolTipMessage={TOOLTIP.aquiferName}
          isSkeleton={isLoading}
          labelId='aquiferName'
          label='Aquifer name'
        >
          <ReadOnlyField isSkeleton={isLoading} labelledBy='aquiferName' value={fields?.aquifer?.aquiferName ?? ''} />
        </FormField>
        <FormField isSkeleton={isLoading} labelId='aquiferDescription' label='Aquifer description'>
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy='aquiferDescription'
            value={fields?.aquifer?.description ?? ''}
          />
        </FormField>
        <FormField isSkeleton={isLoading} labelId='aquiferType' label='Confinement status'>
          <ReadOnlyField isSkeleton={isLoading} labelledBy='aquiferType' value={fields?.aquiferType ?? ''} />
        </FormField>
        <FormField isSkeleton={isLoading} labelId='waterManagementZone' label='Water management zone'>
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy='waterManagementZone'
            value={fields?.waterManagementZone ?? ''}
          />
        </FormField>
        <FormField isSkeleton={isLoading} labelId='waterAllocationZone' label='Water allocation zone '>
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy='waterAllocationZone'
            value={fields?.waterAllocationZone ?? ''}
          />
        </FormField>
        <RecordFooter areActionsFixed={true}>
          <WellViewButtons wellId={id} />
        </RecordFooter>
      </RecordContent>
    </>
  )
}
